<div
  *ngIf="errorCount() > 0"
  class="flex justify-center mb-[14px] tablet:mb-[24px]"
  id="mach-core-flight-status-error-container"
>
  <idp-error-message
    [errorMessage]="'To continue, please correct the'"
    [cntError]="errorCount()"
    (firstInvalidFieldFocusEvent)="focusFirstErrorField()"
  ></idp-error-message>
</div>
<!-- Main Container -->
<section
  class="w-[343px] flex flex-col items-start !p-0 gap-16 tablet:w-[704px] tablet:items-center laptop:w-[992px] laptop:flex-col laptop:justify-center laptop:items-center laptop:px-8 laptop:py-6 laptop:gap-6 laptop:bg-white laptop:rounded-b-02 ultrawide:w-[1440px] ultrawide:px-36 ultrawide:py-6 ultrawide:gap-6 ultrawide:bg-white ultrawide:rounded-b-02"
  id="mach-core-flight-status-section"
>
  <!-- Form Container -->
  <form
    [formGroup]="flightStatusForm"
    class="isolate relative z-20 w-[343px] flex flex-col items-start p-[16px] gap-2 bg-white shadow-01 rounded-02 tablet:w-[704px] tablet:p-16 tablet:items-start laptop:w-[928px] laptop:flex-row laptop:items-start laptop:gap-24 laptop:p-0 laptop:bg-transparent laptop:shadow-none laptop:rounded-none laptop:relative ultrawide:w-[1152px] ultrawide:flex-row ultrawide:gap-[32px] ultrawide:items-start ultrawide:order-1 ultrawide:flex-none ultrawide:p-0 mobile:bg-surface-02 tablet:gap-12"
    [ngClass]="{
      'tablet:!w-[736px]': errorCount() > 0,
      'laptop:!w-[944px] laptop:!p-0 laptop:!items-start': errorCount() > 0,
      'ultrawide:!w-[1440px] ultrawide:!gap-[32px] ultrawide:!rounded-b-02 ultrawide:!px-36 ultrawide:!pt-6 ultrawide:!items-start ultrawide:!justify-center':
        errorCount() > 0
    }"
    role="search"
    [attr.aria-label]="'Flight status search'"
  >
    <fieldset class="contents">
      <legend class="sr-only">
        Search by date and flight number or airport route
      </legend>
      <!-- Input Section - Wrapper removed from tablet layout via display: contents -->
      <div
        class="ultrawide:w-[966px] ultrawide:flex ultrawide:flex-row ultrawide:gap-[24px] ultrawide:items-start ultrawide:p-0 laptop:w-[759px] laptop:flex laptop:flex-row laptop:gap-24 laptop:items-start laptop:justify-between flex flex-col gap-[12px] tablet:contents"
        [ngClass]="{
          'laptop:!gap-[24px] laptop:!w-[775px] ultrawide:!gap-[24px] ultrawide:!w-[966px]':
            errorCount() > 0
        }"
      >
        <!-- Fields Container - Wrapper removed from tablet layout via display: contents -->
        <div
          class="ultrawide:w-[517px] ultrawide:flex ultrawide:flex-row ultrawide:gap-[12px] ultrawide:items-start ultrawide:p-0 laptop:w-[404px] laptop:flex laptop:flex-row laptop:gap-[12px] laptop:items-start flex flex-col gap-12 tablet:contents"
          [ngClass]="{
            'laptop:!w-[420px] ultrawide:!w-[517px]': errorCount() > 0
          }"
        >
          <!-- Date Field - FIGMA: width: 252.5px; height: 64px; order: 0 -->
          <div
            id="mach-core-flight-status-date"
            class="ultrawide:w-[252.5px] ultrawide:min-w-[252.5px] ultrawide:max-w-[252.5px] ultrawide:order-0 laptop:w-[196px] laptop:order-0 tablet:w-[672px] tablet:order-0 order-0 flex flex-col flex-shrink-0"
            [ngClass]="{
              'tablet:!w-[704px] laptop:!w-[204px] ultrawide:!w-[252.5px]':
                errorCount() > 0
            }"
          >
            <div class="relative">
              <button
                type="button"
                id="flight-status-date-trigger"
                class="box-border flex flex-col justify-center items-start px-16 gap-1 ultrawide:w-[252.5px] laptop:w-[196px] tablet:w-[672px] w-full h-16 bg-white border rounded-[6px] cursor-pointer grayscale-bg-color focus:border-transparent focus:outline focus:outline-2 focus:!outline-stroke-04 focus-visible:border-transparent focus-visible:outline focus-visible:outline-2 grayscale-effect"
                [ngClass]="{
                  'tablet:!w-[704px] laptop:!w-[204px] ultrawide:!w-[252.5px]':
                    errorCount() > 0,
                  'outline-stroke-alert': errors['departureDate'] !== '',
                  'border-stroke-01': errors['departureDate'] === ''
                }"
                (click)="openDatePicker()"
                [class.border-2]="errors['departureDate']"
                [class.border-alert]="errors['departureDate']"
                [attr.aria-label]="'Select departure date'"
                aria-expanded="false"
                aria-haspopup="dialog"
                [attr.aria-describedby]="
                  errors['departureDate'] ? 'departureDate-error' : null
                "
                [attr.aria-invalid]="
                  errors['departureDate'] && !isDepartureDateFocused
                    ? 'true'
                    : 'false'
                "
                (focus)="isDepartureDateFocused = true"
                (blur)="isDepartureDateFocused = false"
                id="mach-core-flight-status-date-button"
              >
                <span class="text-caption-medium text-heading">
                  {{
                    content.inputFields.departureDate.title || 'Search By Date*'
                  }}
                </span>
                <span class="text-label-md-medium text-heading">
                  {{
                    selectedDateText ||
                      content.inputFields.departureDate.placeHolder ||
                      'Select date'
                  }}
                </span>
                <svg
                  class="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 text-heading"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    d="M13.165 1.68848C13.6922 1.6839 13.8291 2.15448 13.834 2.17188V3.14062C13.834 3.14062 15.6711 3.13597 16.2666 3.14062C16.8477 3.21239 16.875 3.68555 16.875 3.68555V14.6377C16.875 14.6377 16.9167 15.1499 15.9014 15.1826C13.3766 15.188 5.82211 15.1901 1.61133 15.1826C1.19801 15.1323 1.125 14.5771 1.125 14.5771V3.74609C1.125 3.74609 1.19012 3.15236 1.7334 3.14062C2.27219 3.12906 4.13174 3.14042 4.16504 3.14062V2.17188C4.16918 2.15813 4.32181 1.66566 4.83398 1.68848C5.34353 1.71144 5.49711 2.1545 5.50293 2.17188V3.14062H8.30078V2.17188C8.30483 2.15491 8.41982 1.69531 8.96973 1.68848C9.52083 1.68178 9.63518 2.15674 9.63867 2.17188V3.14062H12.4961V2.17188C12.4985 2.15639 12.5772 1.68787 13.165 1.68848ZM2.46387 13.8516H15.5381V7.49707H2.46387V13.8516ZM2.46387 6.16602H15.5381V4.47168H2.46387V6.16602Z"
                  />
                </svg>
              </button>
              <div
                id="flight-status-date-picker"
                class="date-picker z-50 laptop:absolute laptop:top-20 laptop:z-[9999] ultrawide:absolute ultrawide:top-20 ultrawide:z-[9999]"
              ></div>
            </div>
            <div
              id="departureDate-error"
              class="text-caption-medium text-alert mt-1"
              *ngIf="errors['departureDate']"
              role="alert"
              aria-live="polite"
            >
              {{ errors['departureDate'] }}
            </div>
          </div>

          <!-- Flight Number Field - FIGMA: width: 252.5px; height: 64px; order: 1 -->
          <div
            id="mach-core-flight-status-flight-number"
            class="gap-[4px] ultrawide:w-[252.5px] ultrawide:min-w-[252.5px] ultrawide:max-w-[252.5px] ultrawide:order-1 laptop:w-[196px] laptop:order-1 tablet:w-[672px] tablet:order-1 order-1 flex flex-col flex-shrink-0"
            [ngClass]="{
              'tablet:!w-[704px] laptop:!w-[204px] ultrawide:!w-[252.5px]':
                errorCount() > 0
            }"
          >
            <div class="relative">
              <input
                class="single-line-input ultrawide:w-[252.5px] laptop:w-[196px] tablet:w-[672px] w-full h-16 !border-stroke-01"
                [ngClass]="{
                  'tablet:!w-[704px] laptop:!w-[204px] ultrawide:!w-[252.5px]':
                    errorCount() > 0
                }"
                id="flightNumber"
                type="text"
                inputmode="numeric"
                [placeholder]="
                  content.inputFields.flightNumber.placeHolder || 'ex. 1049'
                "
                maxlength="9"
                pattern="[0-9]*"
                formControlName="flightNumber"
                (input)="onFlightNumberInput($event)"
                [class.!border-0]="errors['flightNumber']"
                [style.border-width]="errors['flightNumber'] ? '3px' : null"
                [attr.aria-describedby]="
                  errors['flightNumber'] ? 'flightNumber-error' : null
                "
                [attr.aria-invalid]="
                  errors['flightNumber'] && !isFlightNumberFocused
                    ? 'true'
                    : 'false'
                "
                aria-required="false"
                autocomplete="off"
                (focus)="isFlightNumberFocused = true"
                (blur)="isFlightNumberFocused = false"
              />
              <label for="flightNumber" class="static-title">
                {{ content.inputFields.flightNumber.title || 'Flight Number*' }}
              </label>
            </div>
            <div
              id="flightNumber-error"
              class="text-caption-medium text-alert mt-1"
              *ngIf="errors['flightNumber']"
              role="alert"
              aria-live="polite"
            >
              {{ errors['flightNumber'] }}
            </div>
          </div>
        </div>

        <!-- OR Label - FIGMA: width: 18px; height: 24px; order: 1 -->
        <div
          class="laptop:h-[64px] ultrawide:w-[18px] ultrawide:order-1 ultrawide:flex ultrawide:items-center ultrawide:justify-center laptop:w-[18px] laptop:order-1 laptop:flex laptop:items-center laptop:justify-center tablet:w-[672px] tablet:order-2 tablet:flex tablet:items-center tablet:justify-center order-2 flex items-center justify-center"
          [ngClass]="{
            'tablet:!w-[704px]': errorCount() > 0
          }"
        >
          <span
            class="text-label-lg-medium text-heading laptop:text-label-lg-medium"
          >
            or
          </span>
        </div>

        <!-- Airport Code Field - FIGMA: width: 383px; height: 80px; order: 2 -->
        <div
          id="mach-core-flight-status-airport"
          class="ultrawide:w-[383px] ultrawide:order-2 laptop:w-[289px] laptop:order-2 tablet:w-[672px] tablet:order-3 order-3 flex flex-col"
          [ngClass]="{
            'tablet:!w-[704px]': errorCount() > 0,
            'tablet:h-[80px] mobile:h-[100px]':
              errors['origin'] || errors['destination']
          }"
        >
          <div
            id="flight-status-airport-code"
            class="airport-code ultrawide:!w-[383px] ultrawide:!min-w-[383px] ultrawide:!max-w-[383px] laptop:!w-[289px] laptop:!min-w-[289px] laptop:!max-w-[289px] tablet:w-[672px] w-full !border-stroke-01"
            [ngClass]="{
              'tablet:!w-[704px]': errorCount() > 0,
              'error-layout': errorCount() > 0
            }"
            [class.has-error]="
              errors['origin'] || errors['destination'] || errors['route']
            "
            [attr.aria-describedby]="
              errors['origin']
                ? 'origin-error'
                : errors['destination']
                ? 'destination-error'
                : errors['route']
                ? 'route-error'
                : null
            "
            [attr.aria-invalid]="
              errors['origin'] || errors['destination'] || errors['route']
                ? 'true'
                : 'false'
            "
          ></div>
          <div *ngIf="errorCount() > 0" class="mt-[4px] laptop:min-h-[16px]">
            <div
              id="route-error"
              class="text-caption-medium text-alert w-[171.5px] tablet:w-[326px] laptop:w-[119px] ultrawide:w-[166px] mobile:w-[130px]"
              *ngIf="errors['route']"
              role="alert"
              aria-live="polite"
            >
              {{ errors['route'] }}
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <!-- Search Button - Hidden on Mobile/Tablet, Shown on Laptop/Ultrawide -->
    <div
      id="mach-core-flight-status-submit-desktop"
      class="hidden tablet:hidden laptop:flex laptop:w-[145px] laptop:order-1 laptop:flex-col laptop:justify-center laptop:items-center ultrawide:w-[154px] ultrawide:order-1 ultrawide:flex ultrawide:flex-col ultrawide:justify-center ultrawide:items-start ultrawide:p-0 ultrawide:gap-2"
    >
      <button
        #searchButtonDesktop
        id="flightStatusSearchButton"
        type="button"
        class="button button-primary button-lg laptop:w-[145px] laptop:h-16 ultrawide:w-[154px] ultrawide:h-16"
        data-acdl-name="flight status:search"
        data-acdl-action="header:flight status:search"
        data-acdl-page-section="header:flight status:search"
        (click)="
          triggerFlightStatus(); analyticsEvent.emit(searchButtonDesktop)
        "
        [disabled]="isLoading"
        [attr.aria-label]="'Search for flight status'"
      >
        <span
          *ngIf="isLoading"
          class="component-loader"
          aria-hidden="true"
        ></span>
        <span [class.sr-only]="isLoading">
          {{ content.action.label || 'Search' }}
        </span>
      </button>
    </div>
  </form>

  <!-- Search Button for Mobile & Tablet -->
  <div
    id="mach-core-flight-status-submit-mobile"
    class="w-[343px] h-16 flex flex-col justify-center tablet:w-[704px] laptop:hidden ultrawide:hidden relative z-10"
    [ngClass]="{
      'tablet:!w-[736px]': errorCount() > 0
    }"
  >
    <button
      #searchButtonMobile
      type="button"
      class="button button-primary button-lg w-full h-16"
      data-acdl-name="flight status:search"
      data-acdl-action="header:flight status:search"
      data-acdl-page-section="header:flight status:search"
      (click)="triggerFlightStatus(); analyticsEvent.emit(searchButtonMobile)"
      [disabled]="isLoading"
      [attr.aria-label]="'Search for flight status'"
    >
      <span
        *ngIf="isLoading"
        class="component-loader"
        aria-hidden="true"
      ></span>
      <span [class.sr-only]="isLoading">
        {{ content.action.label || 'Search' }}
      </span>
    </button>
  </div>
</section>
